import store from "@/store"
import { _changeState } from '@/store/virtualKeyboard/virtualKeyboard'

function onKeyboardStateChanged(status: boolean) {
  const dispatch = store.dispatch
  dispatch(_changeState(status))
}

window.onKeyboardStateChanged = onKeyboardStateChanged
